<div>
    <div *ngIf="driverProcessDetailList?.length!= 0" class="driver-process-detail-content">
        <mat-table class="orders-table" style="border-radius: 10px 10px 0px 0px;" #table [dataSource]="dataSource"
            matSort [@animateStagger]="{value:'50'}" matSortActive="visitDate" matSortDirection="desc"
            fusePerfectScrollbar>

            <ng-container matColumnDef="containerName">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CONTAINER' |translate}}</mat-header-cell>
                <mat-cell *matCellDef="let driverProcessDetail">
                    {{driverProcessDetail.container.name!=null?driverProcessDetail.container.name:'---'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="carLocation">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CAR_LOCATION' |translate}}</mat-header-cell>
                <mat-cell *matCellDef="let driverProcessDetail">
                    <a *ngIf="driverProcessDetail.carLat!=null" matTooltip="{{driverProcessDetail.carLat+'/'+driverProcessDetail.carLng}}"
                        href="javascript:void(null)" (click)="onContainerMap(driverProcessDetail.carLat,driverProcessDetail.carLng)">
                        <mat-icon>map</mat-icon>
                    </a>
                    <span *ngIf="driverProcessDetail.carLat==null">---</span>
                </mat-cell>
            </ng-container>


            <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'STATUS' |translate}}</mat-header-cell>
                <mat-cell *matCellDef="let driverProcessDetail">
                    {{driverProcessDetail.status!=null?(driverProcessDetail.status | translate):'---'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="streetDesc">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'CONTAINER_ADDRESS' |translate}}</mat-header-cell>
                <mat-cell *matCellDef="let driverProcessDetail">
                    {{driverProcessDetail.container.streetDesc!=null?driverProcessDetail.container.streetDesc:'---'}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="visitDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header>{{'VISIT_DATE'|translate}}
                </mat-header-cell>
                <mat-cell *matCellDef="let driverProcessDetail">
                    {{driverProcessDetail.visitDate!=null?(driverProcessDetail.visitDate |date:"dd/MM/y HH:mm"):'---'}}
                </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
            <mat-row *matRowDef="let shift columns: displayedColumns;" class="order" matRipple>
            </mat-row>
        </mat-table>

        <mat-paginator #paginator [length]="paginator.length" [pageSize]="10" [pageSizeOptions]="[10, 50, 100]">
        </mat-paginator>
    </div>

    <div *ngIf="driverProcessDetailList?.length == 0">
        <h2>{{'NO_RECORDS_FOUND'| translate}}</h2>
    </div>
</div>